import Grid from '@material-ui/core/Grid'
import Search from 'Components/Search'
import User from 'EurestoClass/User'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import Utils from 'EurestoFonction/Utils'
import React, { Component } from 'react'
import { browserHistory } from 'react-router'
import Datagrid from '../../../../SDD/Component/Datagrid'


export default class TwitterEmbed extends Component {
  constructor (props) {
    super(props)
    this.state = {
      dataLength: 0,
      key: Utils.getRandomNumber(),
      search: Utils.getRandomNumber()
    }
  }

  viewDossier (row) {
    browserHistory.push({
      pathname: '/crm/' + row.contact_id,
      state: {
        dossier_id: row.dossier_id && row.dossier_id || undefined,
        classeur_id: row.classeur_id,
        UserTabSelected: 2,
        action_id: row.action_id,
        dossier_status: row.status
      }
    })
  }

  render () {
    return (
      <Grid item style={{ margin: 0, padding: 10 }} xs={12}>
        <div style={{ display: 'none' }}>
          <Search
            unsave
            //style={{ fontSize: 12, padding: 2, right: 10, position: 'absolute', top: -56 }}
            limit={30}
            all
            search={'dossier_' + (this.state.search || '') + User.Entite.get().id}
            defaultSearchPriority
            defaultSearch={{
              '?actif': 1,
              'type_action_id': [1,2,3,31],
              'type_action_id_non': true,
              'sdd_classeur.visible': 1,
              'etat': 0,
              $or: {
                user_assign_id: User.User.get().id,
                user_id: User.User.get().id
              },
              '[[group_by]]': !User.User.get().regroupement_tache && 'sdd_action.id' || 'sdd_action.contact_id,sdd_action.classeur_id,sdd_action.dossier_id'
            }}
            path={'sdd'}
            requete={'dossier'}>
          </Search>
        </div>
        <EurestoDiv title={this.props.libelle} style={{ height: 400, maxHeight: 400 }}>
          <Datagrid
            view={'list'}
            data={this.props.data}
            type={this.props.type}
            style={{ maxHeight: 400, padding: 0, margin: 0, width: '100%', maxWidth: '100%' }}
            onClick={this.viewDossier}
            search={'dossier_' + (this.state.search || '') + User.Entite.get().id}
          >
          </Datagrid>
        </EurestoDiv>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./app/App/Module/Home/Component/Widgets/SuiviDossier/index.js